import { deleteDefinition } from "state/grid/util";
import { COMMIT_SELECTIONS } from "state/selections/actions";
import {
  RECEIVE_DATA,
  RECEIVE_RATIO_DATA,
  REQUEST_DATA,
  REQUEST_RATIO_DATA,
  SET_DEFINITION,
  SET_DEFINITIONS,
  DELETE_DEFINITION,
  RECEIVE_SBS_DATA,
  REQUEST_SBS_DATA,
} from "./actions";
import SelectionState from "state/selections/SelectionState";
import { SummaryType } from "@ls/grouping-service";
import produce from "immer";

const defaultState = {
  definitions: {
    [SelectionState.UNCOMMITTED]: [],
    [SelectionState.COMMITTED]: [],
  },
  data: {
    [SummaryType.ABSOLUTE]: null,
    [SummaryType.RELATIVE]: null,
  },
  ratioData: {
    [SummaryType.ABSOLUTE]: null,
    [SummaryType.RELATIVE]: null,
  },
  sbsData: {
    [SummaryType.ABSOLUTE]: null,
    [SummaryType.RELATIVE]: null,
  },
  fetchingData: {
    [SummaryType.ABSOLUTE]: false,
    [SummaryType.RELATIVE]: false,
  },
  fetchingRatioData: {
    [SummaryType.ABSOLUTE]: false,
    [SummaryType.RELATIVE]: false,
  },
  fetchingSbsData: {
    [SummaryType.ABSOLUTE]: false,
    [SummaryType.RELATIVE]: false,
  },
};

const reducer = produce((state = defaultState, action) => {
  switch (action.type) {
    case SET_DEFINITION: {
      const { definition, idx } = action;
      const selectedDefinitions = state.definitions[SelectionState.UNCOMMITTED];
      if (definition === null) {
        selectedDefinitions.splice(idx, 1);
      } else {
        selectedDefinitions[idx] = definition;
      }
      break;
    }
    case DELETE_DEFINITION:
      state.definitions = deleteDefinition(state.definitions, action.payload);
      break;
    case SET_DEFINITIONS: {
      state.definitions[SelectionState.UNCOMMITTED] = action.definitions;
      break;
    }
    case COMMIT_SELECTIONS: {
      state.data = defaultState.data;
      state.ratioData = defaultState.ratioData;
      state.sbsData = defaultState.sbsData;
      state.definitions[SelectionState.COMMITTED] =
        state.definitions[SelectionState.UNCOMMITTED];
      break;
    }
    case REQUEST_DATA: {
      state.fetchingData[action.summary] = true;
      state.data[action.summary] = defaultState.data[action.summary];
      break;
    }
    case RECEIVE_DATA: {
      state.fetchingData[action.summary] = false;
      state.data[action.summary] = action.data;
      break;
    }
    case REQUEST_RATIO_DATA: {
      state.fetchingRatioData[action.summary] = true;
      state.ratioData[action.summary] = defaultState.ratioData[action.summary];
      break;
    }
    case RECEIVE_RATIO_DATA: {
      state.fetchingRatioData[action.summary] = false;
      state.ratioData[action.summary] = action.data;
      break;
    }
    case REQUEST_SBS_DATA: {
      state.fetchingSbsData[action.summary] = true;
      state.sbsData[action.summary] = defaultState.sbsData[action.summary];
      break;
    }
    case RECEIVE_SBS_DATA: {
      state.fetchingSbsData[action.summary] = false;
      state.sbsData[action.summary] = action.data;
      break;
    }
    default:
      return state;
  }
});
export default reducer;
